import styled, { css } from "styled-components";
import OutlinedCard from "ui/common/components/surface/OutlinedCard/OutlinedCard";
import { Image } from "@commonlibs";

export const BaseCard = styled(OutlinedCard)(
    ({ theme }) => css`
        width: 100%;
        padding: ${theme.spacing.all(6, 8)};
    `,
);

export const PointImage = styled(Image)(
    ({ theme }) => css`
        width: 7.75rem;
        height: 7.75rem;
        border-radius: ${theme.borderRadius};
    `,
);
